function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.79.5c1.194 0 2.39.434 3.267 1.31A4.414 4.414 0 0119.5 5.093c0 1.22-.483 2.458-1.443 3.417h0l-1.236 1.235-6.883 6.876L3.047 9.57 1.81 8.335A4.473 4.473 0 01.5 5.16c0-1.15.436-2.301 1.31-3.174C2.69 1.028 3.827.55 4.986.523c1.189-.03 2.398.411 3.366 1.294h0l1.582 1.58 1.59-1.588C12.4.934 13.595.5 14.79.5z",
  fillRule: "nonzero",
  stroke: "currentColor",
  fill: "none"
});
function SvgSaveDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgSaveDefault;